import { MabyeWrappedError } from "./MaybeWrappedError";

// Required for docstring.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import type { SilentError } from "./SilentError";
// Required for docstring.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import type { ErrorReporterService } from "src/services/error-reporter.service";

/**
 * Represents an error that does not need to be reported to the end user.
 * Either because it has already been reported, or because end user feedback
 * makes no sense for this particular error.
 *
 * If you want also want to omit debug printing in the If this is passed to
 * {@link ErrorReporterService.prototype.handle | ErrorReporterService#handle} method,
 * please use {@link SilentError}
 */
export class NonUserError extends MabyeWrappedError {}
